import React, { useEffect, useMemo, useState } from "react";
import "../styles/AQuienesBuscamos.css";
import {
  FaBriefcase,
  FaBusinessTime,
  FaClinicMedical,
  FaGraduationCap,
} from "react-icons/fa";

const imageContext = require.context(
  "../imgs/personas-ayudamos",
  false,
  /\.(png|jpe?g|webp)$/i
);

const studentProfiles = [
  {
    icon: FaGraduationCap,
    title: "Personas que quieren iniciar en el area de salud",
    text: "Si buscas tu primer acercamiento profesional a enfermeria, fisioterapia, podologia clinica, masoterapia o quiropractica, nuestros cursos te ayudan a construir una base practica.",
  },
  {
    icon: FaBriefcase,
    title: "Quienes quieren mejorar su empleo o certificar experiencia",
    text: "Si ya trabajas, cuidas pacientes o tienes habilidades aprendidas en la practica, una certificacion puede ayudarte a respaldar lo que sabes hacer.",
  },
  {
    icon: FaBusinessTime,
    title: "Personas que buscan generar ingresos o autoemplearse",
    text: "Nuestros programas estan pensados para desarrollar habilidades que puedas aplicar en servicios profesionales, campanas de salud o proyectos propios.",
  },
  {
    icon: FaClinicMedical,
    title: "Alumnos de Ixtapaluca y la Zona Oriente",
    text: "Atendemos personas de Ixtapaluca, Chalco, Valle de Chalco y Estado de Mexico que quieren estudiar cerca, con acompanamiento y enfoque practico.",
  },
];

const imageAltByName = {
  "alumna-certificada-fundacion-nican":
    "Alumna certificada de Fundacion Nican con diploma profesional",
  "alumnos-graduados-certificacion-sep":
    "Alumnos graduados con certificacion SEP en Fundacion Nican",
  "egresado-con-diploma-profesional":
    "Egresado con diploma profesional de Fundacion Nican",
  "graduacion-certificaciones-fundacion-nican":
    "Graduacion de certificaciones profesionales en Fundacion Nican",
  "historias-de-exito-fundacion-nican":
    "Historia de exito de estudiante de Fundacion Nican",
  "personas-capacitadas-para-el-empleo":
    "Personas capacitadas para el empleo en Fundacion Nican",
};

const buildAlt = (fileName) => {
  const cleanName = fileName.replace(/\.(png|jpe?g|webp)$/i, "");
  return (
    imageAltByName[cleanName] ||
    `${cleanName.replace(/-/g, " ")} en Fundacion Nican`
  );
};

const proofImages = imageContext
  .keys()
  .sort((a, b) => a.localeCompare(b))
  .map((key) => {
    const fileName = key.replace("./", "");

    return {
      src: imageContext(key),
      alt: buildAlt(fileName),
      key: fileName,
    };
  });

const getCircularImage = (images, startIndex, offset) => {
  if (!images.length) return null;
  return images[(startIndex + offset) % images.length];
};

function AQuienesBuscamos() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (proofImages.length <= 3 || isPaused) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % proofImages.length);
    }, 3600);

    return () => window.clearInterval(timer);
  }, [isPaused]);

  const visibleImages = useMemo(
    () =>
      [0, 1, 2]
        .map((offset) => getCircularImage(proofImages, activeIndex, offset))
        .filter(Boolean),
    [activeIndex]
  );

  return (
    <section id="a-quienes-buscamos" className="audience-section">
      <div className="container">
        <div className="audience-heading">
          <span className="audience-eyebrow">Elige con claridad</span>
          <h2>Para quienes son nuestros cursos</h2>
          <p>
            Nuestros programas son para personas que quieren aprender una
            habilidad util, crecer profesionalmente y convertir su formacion en
            una oportunidad real de empleo, certificacion o autoempleo.
          </p>
        </div>

        <div className="audience-layout">
          <div className="audience-cards">
            {studentProfiles.map((profile) => {
              const Icon = profile.icon;

              return (
                <article className="audience-card" key={profile.title}>
                  <div className="audience-icon">
                    <Icon />
                  </div>
                  <div>
                    <h3>{profile.title}</h3>
                    <p>{profile.text}</p>
                  </div>
                </article>
              );
            })}
          </div>

          <aside className="audience-proof">
            <div
              className="audience-gallery"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => {
                setPreviewImage(null);
                setIsPaused(false);
              }}
            >
              <div className="audience-image-grid">
                {visibleImages.map((image, index) => (
                  <figure
                    className={`audience-photo ${
                      index === 0
                        ? "audience-photo-large"
                        : "audience-photo-medium"
                    }`}
                    key={`${image.key}-${index}`}
                    onMouseEnter={() => setPreviewImage(image)}
                    onFocus={() => setPreviewImage(image)}
                  >
                    <img src={image.src} alt={image.alt} loading="lazy" />
                    {index === 0 && (
                      <figcaption>Formacion practica con respaldo</figcaption>
                    )}
                  </figure>
                ))}
              </div>

              {previewImage && (
                <div className="audience-photo-preview" aria-hidden="true">
                  <img src={previewImage.src} alt="" />
                </div>
              )}
            </div>

            <div className="audience-summary">
              <strong>¿No sabes que curso elegir?</strong>
              <p>
                Te orientamos segun tu experiencia, disponibilidad y objetivo:
                conseguir empleo, certificarte o emprender un servicio propio.
              </p>
              <a href="#contact">Recibir orientacion</a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default AQuienesBuscamos;
